var styles = {
  "Callout": "pb-Callout__Callout",
  "icon": "pb-Callout__icon",
  "information": "pb-Callout__information",
  "error": "pb-Callout__error",
  "success": "pb-Callout__success",
  "warning": "pb-Callout__warning",
  "key-information": "pb-Callout__key-information"
};
export default styles;